// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"settingsSupplierCreateView_form-wrapper__b8Ury"};